module.exports = __webpack_public_path__ + "static/media/may 2022.ec7e2da7.svg";